<template>
  <v-container class="pa-0 white--text">
    <v-row justify="center" class="fill-height my-3">



<!-- 
      <v-btn 
              :to="'/perfiles/'"
              class="ma-0 google-font elevation-1" 
              color="#1a73e8" 
              style="text-transform: capitalize;border-radius: 5px; color: white;"
              
              >Buscador de perfiles públicos
              </v-btn> -->




      <!-- <v-col cols="12" class="pa-2">
        <p class="google-font" style="font-size: 150%">
          About {{ chapterDetails.ChapterName }}
        </p>
        <p class="google-font" style="font-size: 110%">
          {{ chapterDetails.ChapterLongDec }}
        </p>
        <v-btn
          :href="chapterDetails.ChapterMeetupLink"
          target="_blank"
          outlined
          color="white"
          class="ma-0 google-font"
          style="border-radius: 5px; text-transform: capitalize;"
        >
          Meetup Page
        </v-btn>
        &nbsp;
        <v-btn
          :href="chapterDetails.socialLinks[0].link"
          target="_blank"
          outlined
          color="white"
          class="ma-0 google-font"
          style="border-radius: 5px; text-transform: capitalize;"
        >
          Facebook Page
        </v-btn>
        <br /><br />
        <router-link
          to="/about"
          class="google-font"
          style="text-decoration: none; color: white"
        >
          See More about {{ chapterDetails.ChapterName }}
        </router-link>
      </v-col>-->
    </v-row> 
  </v-container>
</template>

<script>
import ChapterDetails from '@/assets/data/chapterDetails.json';

export default {
  data() {
    return {
      chapterDetails: ChapterDetails,
    };
  },
};
</script>

<style scoped>
.google-font {
  font-family: 'Google Sans', sans-serif;
}
</style>
